import React from 'react'
import { useHistory } from 'react-router-dom';
import { useAddNoteToResult, useRetestProcedure, useReviewProcedure, useUpdateFlag } from './dataEgressMutations';
import { useFetchContext } from '../common/FetchContext';
import { useQueryClient } from 'react-query';
import { useAuthContext } from '../common/AuthContext';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@material-ui/core';
import { useDefaultColumn } from '../../util/filter';
import { toast } from 'react-toastify';
import { useView } from './dataEgressQueries';
import { useTestPermissionsVerification } from '../projectManagement/projectQueries';
import { ErrorMessage } from '../common/ErrorMessage';
import { processErrorOnMutation } from '../../util/errorMessaging';
import { TravelerModalButton } from './TravelerModalButton';
import { ThreadedCreator } from '../common/threadedViewer/threadedCreator';
import { VisualizerNotesModal } from './VisualizerNotesModal';
import { formatDate } from '../common/formatDate';
import { ConfirmationDialog } from '../common/ConfirmationDialog';
import CloseIcon from "@material-ui/icons/Close";
import { EdgePinchVisual } from './EdgePinchVisual';


export const EdgePinchModel = ({
    id,
    name,
    disposition,
    dispositionPassedId,
    open_notes,
    has_notes,
     isComments,
    onOpenNotes,
}: {
    id: any;
    name: any;
    disposition: any;
    dispositionPassedId?: any;
    open_notes: any;
    has_notes: any;
    isComments?: any;
    onOpenNotes?: any;
}) => {

    const history = useHistory();
    const { mutateAsync: mutateRetestProcedure } = useRetestProcedure();
    const { mutateAsync: mutateReviewProcedure } = useReviewProcedure();
    const { authAxios } = useFetchContext();
    const queryClient = useQueryClient();
    const { dispatch } = useAuthContext();

    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [procedureResultData, setProcedureResultData] = React.useState([]);
    const [confirmationDialogRetestOpen, setConfirmationDialogRetestOpen] =
        React.useState(false);
    const [confirmationDialogApproveOpen, setConfirmationDialogApproveOpen] =
        React.useState(false);
    const theme = useTheme();
    const defaultColumn = useDefaultColumn();
    const { mutateAsync: mutateNote } = useAddNoteToResult();
    const NOT_AVAILABLE = "N/A";

    const [flagChecked, setFlagCheck] = React.useState(false);
    const [flagDialog, setFlagDialog] = React.useState(false)
    const { mutateAsync: mutateUpdateFlag } = useUpdateFlag();


    const submitFlagUpdate = async () => {
        try {

            if (flagChecked) {
                await mutateUpdateFlag({
                    authAxios,
                    id: procedureData.id,
                    final_result: false
                });
                setFlagCheck(false)
            } else {
                await mutateUpdateFlag({
                    authAxios,
                    id: procedureData.id,
                    final_result: true
                });
                setFlagCheck(true)
            }
            toast.success("Request Submited Successfully");
            setFlagDialog(false)
            queryClient.invalidateQueries("travelerResults");


        } catch (error) {
            toast.error("Request Submition Failed");
            setFlagDialog(false)
        }

    };
    const {
        data: procedureData,
        error: procedureError,
        isLoading: isLoadingProcedure,
        isError: isErrorProcedure,
        isSuccess: isSuccessProcedure,
    } = useView(id, isOpen);

    const { data: permission, isLoading: isLoadingPermission } =
        useTestPermissionsVerification(id, isOpen);

    React.useEffect(() => {
        if (isSuccessProcedure) {
            procedureData.final_result ? setFlagCheck(true) : setFlagCheck(false)
            setProcedureResultData(procedureData.step_results);
        }
    }, [isSuccessProcedure, procedureData]);

    if (isLoadingProcedure || isLoadingPermission) {
        return (
            <div style={theme.containerMargin}>
                <Grid>
                    <Grid item xs={12}>
                        <LinearProgress />
                    </Grid>
                </Grid>
            </div>
        );
    }

    if (isErrorProcedure) {
        return <ErrorMessage error={procedureError} />;
    }


    const edgePinchData = procedureData?.edge_pinch;

    const positions = Object.entries(
        edgePinchData?.locations?.[0]?.outside_edge || {}
    );

    const calculateAverage = (locations: any, position: any) => {
        const values = locations.map(
            (loc: any) => Number(loc.thickness?.[position] || 0)
        );

        const avg = values.reduce((a: any, b: any) => a + b, 0) / values.length;
        return avg.toFixed(2);
    };

    const calculateStdDev = (locations: any, position: any) => {
        const values = locations.map(
            (loc: any) => Number(loc.thickness?.[position] || 0)
        );

        const avg = values.reduce((a: any, b: any) => a + b, 0) / values.length;

        const variance = values.reduce(
            (acc: any, value: any) => acc + Math.pow(value - avg, 2),
            0
        ) / values.length;

        return Math.sqrt(variance).toFixed(2);
    };
    const toggleOpenState = () => {
        setIsOpen((value) => !value);
    };


    const submitVerification = async (result: boolean) => {
        if (result) {
            try {
                await mutateReviewProcedure({
                    authAxios,
                    disposition: dispositionPassedId,
                    procedure_result: procedureData.id,
                });
                toast.success("Edge Pinch Test Review Approved");
                setConfirmationDialogApproveOpen(false);
                setIsOpen(false);
                queryClient.invalidateQueries("verify_data");
                queryClient.invalidateQueries("travelerResults");
            } catch (error) {
                toast.error("Error while approving Edge Pinch Test");
                processErrorOnMutation(error, dispatch, history);
                setConfirmationDialogApproveOpen(false);
                setIsOpen(false);
                queryClient.invalidateQueries("verify_data");
                queryClient.invalidateQueries("travelerResults");
            }
        } else {
            try {
                await mutateRetestProcedure({
                    authAxios,
                    procedure_result: procedureData.id,
                });
                toast.success("Edge Pinch Test Review was sent for retesting");
                setConfirmationDialogRetestOpen(false);
                setIsOpen(false);
                queryClient.invalidateQueries("verify_data");
                queryClient.invalidateQueries("travelerResults");
            } catch (error) {
                toast.error("Error while retesting Edge Pinch Test");
                processErrorOnMutation(error, dispatch, history);
                setConfirmationDialogRetestOpen(false);
                setIsOpen(false);
                queryClient.invalidateQueries("verify_data");
                queryClient.invalidateQueries("travelerResults");
            }
        }
    };
    return (
        <React.Fragment>
            <TravelerModalButton
                disposition={disposition}
                name={name}
                handleClose={toggleOpenState}
                open_notes={open_notes}
                has_notes={has_notes}
                type="stress"
                isComments={isComments}
                onOpenNotes={onOpenNotes}
            />

            <Dialog open={isOpen} onClose={toggleOpenState} fullWidth maxWidth="lg">
                <DialogTitle id="scroll-dialog-title">
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item xs={8}>
                            <Typography variant="h6">{`${name}`};</Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Typography variant="body2" display="inline">
                                Flag Result:
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <ThreadedCreator
                                id={id}
                                noteType={3}
                                model={"procedure"}
                                invalidate={[""]}
                                typeable={false}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <VisualizerNotesModal
                                procedureId={id}
                                name={`Stress Data Review - ${name}`}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton onClick={toggleOpenState}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent dividers={true}>
                    {procedureData?.supersede && (
                        <Typography variant="body2" align="center">
                            SUPERSEDED
                        </Typography>
                    )}

                    <Grid container spacing={2}>

                        <Grid item xs={8}>
                            <Typography variant="body1">
                                Heading: {procedureData?.procedure_definition_name || "N/A"}
                            </Typography>
                            <Typography variant="body1">
                                Disposition: {procedureData?.disposition_name || "N/A"}
                            </Typography>
                            <Typography variant="body1">
                                Start Date/Time: {formatDate(procedureData?.start_datetime) || NOT_AVAILABLE}
                            </Typography>
                            <Typography variant="body1">
                                End Date/Time: {procedureData?.end_datetime ? formatDate(procedureData.end_datetime) : NOT_AVAILABLE}
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="body1">
                                Asset Name: {procedureData?.assets?.[0]?.[0] || "N/A"}
                            </Typography>
                        </Grid>

                        {procedureData?.edge_pinch && (
                            <>
                                <Grid item xs={5} style={{ marginTop: 20 }}>

                                    <EdgePinchVisual procedureData={procedureData} />
                                </Grid>
                                <Grid item xs={7} style={{ marginTop: 20 }}>

                                    <TableContainer component={Paper}>

                                        <Table>

                                            {/* HEADER */}
                                            <TableHead>

                                                <TableRow>

                                                    <TableCell>
                                                        LOCATION
                                                    </TableCell>

                                                    {Object.keys(
                                                        edgePinchData?.locations?.[0]?.outside_edge || {}
                                                    )
                                                        .sort((a, b) => Number(a) - Number(b))
                                                        .map((key) => (

                                                            <TableCell
                                                                key={key}
                                                                align="center"
                                                            >
                                                                {key} MM
                                                            </TableCell>

                                                        ))}

                                                </TableRow>

                                            </TableHead>

                                            {/* BODY */}
                                            <TableBody>

                                                {[...(edgePinchData?.locations || [])]
                                                    .sort((a, b) =>
                                                        a.location.localeCompare(b.location)
                                                    )
                                                    .map((loc: any) => (

                                                        <TableRow key={loc.location}>

                                                            {/* LOCATION */}
                                                            <TableCell>

                                                                <Typography
                                                                    style={{
                                                                        fontWeight: 600,
                                                                        fontSize: 16
                                                                    }}
                                                                >
                                                                    {loc.location}
                                                                </Typography>

                                                            </TableCell>

                                                            {/* THICKNESS VALUES */}
                                                            {Object.keys(
                                                                loc.outside_edge || {}
                                                            )
                                                                .sort((a, b) => Number(a) - Number(b))
                                                                .map((key) => (

                                                                    <TableCell
                                                                        key={key}
                                                                        align="center"
                                                                    >

                                                                        <Box
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            justifyContent="center"
                                                                            style={{
                                                                                width: 50,
                                                                                height: 20,
                                                                                margin: "0 auto",
                                                                                background: "#fff",

                                                                                fontSize: 14,
                                                                            }}
                                                                        >
                                                                            {loc.thickness?.[key] ?? "-"}
                                                                        </Box>

                                                                    </TableCell>

                                                                ))}

                                                        </TableRow>

                                                    ))}

                                                {/* AVERAGE ROW */}
                                                {/* AVERAGE ROW */}
                                                <TableRow>

                                                    <TableCell
                                                        style={{
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Average
                                                    </TableCell>

                                                    {Object.keys(
                                                        edgePinchData?.locations?.[0]?.outside_edge || {}
                                                    )
                                                        .sort((a, b) => Number(a) - Number(b))
                                                        .map((key) => (

                                                            <TableCell
                                                                key={key}
                                                                align="center"
                                                                style={{
                                                                    fontSize: 14,
                                                                    color: "#0F5F73"
                                                                }}
                                                            >
                                                                {calculateAverage(
                                                                    edgePinchData.locations,
                                                                    key
                                                                )}
                                                            </TableCell>

                                                        ))}

                                                </TableRow>

                                                {/* STD DEV ROW */}
                                                <TableRow>

                                                    <TableCell
                                                        style={{
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Std Dev (σ)
                                                    </TableCell>

                                                    {Object.keys(
                                                        edgePinchData?.locations?.[0]?.outside_edge || {}
                                                    )
                                                        .sort((a, b) => Number(a) - Number(b))
                                                        .map((key) => (

                                                            <TableCell
                                                                key={key}
                                                                align="center"
                                                                style={{

                                                                    fontSize: 14,
                                                                    color: "#0F5F73"
                                                                }}
                                                            >
                                                                {calculateStdDev(
                                                                    edgePinchData.locations,
                                                                    key
                                                                )}
                                                            </TableCell>

                                                        ))}

                                                </TableRow>

                                            </TableBody>

                                        </Table>

                                    </TableContainer>

                                </Grid>
                            </>
                        )}


                        {permission && (
                            <>
                                <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: 16 }}>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            style={theme.btnError}
                                            // disabled={getTheme()}
                                            onClick={() => setConfirmationDialogRetestOpen(true)}
                                        >
                                            Retest
                                        </Button>
                                    </Grid>
                                    {disposition === "Requires Review" && (
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                style={theme.btnNew}
                                                onClick={() => setConfirmationDialogApproveOpen(true)}
                                            >
                                                Approve
                                            </Button>
                                        </Grid>
                                    )}

                                </Grid>
                            </>
                        )}


                    </Grid>

                </DialogContent>``
                <DialogActions>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item xs={1} />

                        <Grid item xs={10} alignItems="center">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={flagChecked}
                                        onChange={() => {
                                            setFlagDialog(true)
                                        }}
                                        name="autoCheck"
                                        color="primary"
                                    // disabled = {getTheme()}
                                    />
                                }
                                label="Final Result"
                            />
                        </Grid>

                    </Grid>


                </DialogActions>
                <ConfirmationDialog
                    id="EdgePinch-review-retest"
                    keepMounted
                    open={confirmationDialogRetestOpen}
                    title="EdgePinch Review Retest Confirmation"
                    content="Are you sure that you want to retest this EdgePinch Review?"
                    onCancel={() => setConfirmationDialogRetestOpen(false)}
                    onSubmit={() => submitVerification(false)}
                />
                <ConfirmationDialog
                    id="EdgePinch-review-approve"
                    keepMounted
                    open={confirmationDialogApproveOpen}
                    title="EdgePinch Review Approval Confirmation"
                    content="Are you sure that you want to approve this EdgePinch Review?"
                    onCancel={() => setConfirmationDialogApproveOpen(false)}
                    onSubmit={() => submitVerification(true)}
                />

                <ConfirmationDialog
                    id="flag-update"
                    keepMounted
                    open={flagDialog}
                    title="Approval Confirmation"
                    content="Please confirm whether the selected result is Correct?"
                    onCancel={() => setFlagDialog(false)}
                    onSubmit={() => submitFlagUpdate()}
                />
            </Dialog>

        </React.Fragment>
    )
}


